'use client';

import openLanguageDropdownTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentHeader/openLanguageDropdownTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { HeaderDropdown } from '@coolblue-development/next-patterns/client';
import { ReactNode } from 'react';

type Props = {
  variant: 'base' | 'unstyled' | 'wide';
  buttonChildren: ReactNode;
  children: ReactNode;
};

export const HeaderDropdownWithAnalytics = ({ variant, buttonChildren, children }: Props) => {
  const { trackEvent } = useAnalytics();

  const handleOpen = () => {
    trackEvent(openLanguageDropdownTrigger());
  };

  return (
    <HeaderDropdown
      placement='right'
      variant={variant}
      onOpen={handleOpen}
      buttonChildren={buttonChildren}
      children={children}
    />
  );
};
